const electionsOptions = [
  { id: 1, name: 'Eleição Municipal 2024 - 1º Turno', is_municipal: true },
];

export default electionsOptions;
